import React, { useState, useEffect } from 'react';

// hooks
import { useRouter } from 'next/router';
import { useMutation, useQuery } from 'react-query';
import useWindowSize from 'hooks/use-windowSize';

import LinkButton from '@core/components/linkbutton/LinkButton';
import Spinner from '@core/components/spinner/Spinner';
// Api call Service
import { confirmVerificationEmailService } from 'services/auth';
import { companyInit } from 'services/company';

// auth utils
import { isUserLoggedIn, getAccessToken } from 'utils/authentication';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import { checkUserInfoFlow } from 'utils/routerUtils';

import FailedVerification from 'assets/images/empty-search.svg';
import SuccessVerification from 'assets/images/email-verify-welcome.png';
import joinPharmuniImg from 'assets/images/join-pharmuni-get-started.png';
import joinPharmuniImgTablet from 'assets/images/join-pharmuni-get-started-tablet.png';
import PartnerPharmuniImg from 'assets/images/join-pharmuni-partner-with-us.png';
import PartnerPharmuniImgTablet from 'assets/images/join-pharmuni-partner-with-us-tablet.png';

import classes from './VerificationEmail.module.scss';


const VerificationEmail = () => {
	const router = useRouter();
	const { desktopDevice } = useWindowSize();
	const [response, setResponse] = useState();
	
	const { mutate: callConfirmVerification, isLoading } = useMutation(
		confirmVerificationEmailService,
		{
			onSuccess: (data) => {
				setResponse('success');
				checkUserInfoFlow({ data: data.data, router });
			},
			onError: () => {
				setResponse('failed');
			}
		}
	);

	useQuery(['company-profile-init', getAccessToken(), isUserLoggedIn()], companyInit.GET, {
		onSuccess: (resp) => {
			if (resp.data.company_invitations && resp.data.company_invitations.length > 0) {
				router.replace('/company', { pathname: '/company', query: { verification: true } });
			}
		},
		enabled: response === 'success',
		refetchOnMount: 'always'
	});

	const seoProps = generateSeoProps({
		title: 'Pharmuni | Verification Email',
		canonical: 'verify-email'
	});

	useEffect(() => {
		if (router?.query?.token && router.isReady) {
			callConfirmVerification(router?.query?.token);
		}
	}, [callConfirmVerification, router?.query?.token]);

	return (
		<>
			<NextSeo {...seoProps} />
			{!isLoading && response ? (
				<div
					className={`${classes['register-verify-wrapper']} d-flex flex-column align-items-center`}>
					<div
						className={`${classes['register-verify']}  d-flex flex-column align-items-md-center`}>
						{response === 'success' && (
							<div className={`d-flex flex-column gap-5`}>
								<div className={`${classes['success-container']}`}>
									<h5>Your email address has now been verified.</h5>
									<h1>Welcome to the Pharmuni Community!</h1>
								</div>
								<div className="container d-flex justify-content-center gap-3">
									<div
										className={`${classes['join-pharmuni-cart']} ${classes['join-pharmuni-cart__get-started']} d-flex flex-row flex-md-row flex-xl-column gap-0 gap-md-0 gap-xl-5`}>
										<img
											src={desktopDevice ? joinPharmuniImg.src : joinPharmuniImgTablet.src}
											alt="join-pharmuni"
										/>
										<div className="d-flex flex-column gap-3 gap-md-4">
											<h2>Unlock Your Potential</h2>
											<LinkButton to="/" kind="primary-color" className="align-self-center">
												Start your learning journey
											</LinkButton>
										</div>
									</div>
									{/* <div
										className={`${classes['join-pharmuni-cart']} ${classes['join-pharmuni-cart__partner']} d-flex flex-row flex-md-row flex-xl-column gap-0 gap-md-0 gap-xl-5`}>
										<img
											src={desktopDevice ? PartnerPharmuniImg.src : PartnerPharmuniImgTablet.src}
											alt="join-pharmuni"
											className="order-2 order-md-2 order-xl-1"
										/>
										<div className="d-flex flex-column gap-3 gap-md-4 order-1 order-md-1 order-xl-2">
											<h2>Empower Collaboration</h2>
											<LinkButton to="/company" kind="primary-color" className="align-self-center">
												Join as a company
											</LinkButton>
										</div>
									</div> */}
								</div>
							</div>
						)}
						{response === 'failed' && (
							<>
								<FailedVerification />
								<h1>Oh oh!</h1>
								<p>
									Your verification link is incorrect or has expired.{' '}
									{isUserLoggedIn() && 'Request for a new verification email.'}
									{!isUserLoggedIn() &&
										'Login again on application to receive a new verification email.'}
								</p>
								{!isUserLoggedIn() && (
									<LinkButton to="/login" state={{ next: '/verification' }}>
										Login
									</LinkButton>
								)}
								{isUserLoggedIn() && (
									<LinkButton to="/verification">Resend Verification</LinkButton>
								)}
							</>
						)}
					</div>
				</div>
			) : (
				<div className="d-flex flex-row align-items-center justify-content-center w-100">
					<Spinner />
				</div>
			)}
		</>
	);
};

export default VerificationEmail;
